import { render, staticRenderFns } from "./yundong-read.vue?vue&type=template&id=a3cfb930&scoped=true&"
import script from "./yundong-read.vue?vue&type=script&lang=ts&"
export * from "./yundong-read.vue?vue&type=script&lang=ts&"
import style0 from "./yundong-read.vue?vue&type=style&index=0&id=a3cfb930&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3cfb930",
  null
  
)

export default component.exports